import React, { Component } from 'react';

import classes from './InternationalTupleDetails.scss';
import InternationalTupleInner from './InternationalTupleInner/InternationalTupleInner';
import planeImage from '../../../../assets/images/plane.svg';

import Tooltip from '../../../UI/Tooltip/Tootip';

import Media from 'react-media';

class InternationalTupleDetails extends Component {

    render() {
        let tupleInner = null;
        const FS = this.props.type === "depart" ?  this.props.intDepartFlights[0].FS : this.props.intReturnFlights[0].FS;
        // let stopCity = null;
        // let stopOver = null;
        // const totalStop = parseInt(this.props.type === "depart" ? this.props.intDepartFlights[0].ts : this.props.intReturnFlights[0].ts, 10);
        const arrivalDuration = this.props.type === "depart" ? this.props.intDepartFlights[0].FS[this.props.intDepartFlights[0].FS.length - 1].ad : this.props.intReturnFlights[0].FS[this.props.intReturnFlights[0].FS.length - 1].ad;    
        let totalStop = null;
        let stop0 = null;
        let stop1 = null;
        let stop2 = null;
        let stopCity0 = null;
        let stopCity1 = null;
        let stopCity2 = null;
        let stopOver = null;
        let allStopovers = [];
        let so0 = null;
        let so1 = null;
        let so2 = null;
        let so3 = null;
        if(FS.length === 1) {
            totalStop = 0;
            if(FS[0].so) {
                so0 = "Via " + FS[0].so.name;
            } else {
                so0 = FS[0].so;
            }
        }
        if(FS.length > 1) {
            totalStop = FS.length - 1;
            if(FS.length === 2) {
                if(FS[0].so) {
                    so0 = "Via " + FS[0].so.name;
                    allStopovers.push(so0);
                }
                if(allStopovers.length === 1) {
                    stop0 = ","
                } else {
                    stop0 = "Via"
                }
                stopCity0 = FS[0].aac;
                allStopovers.push(
                    <span className={`u-phone-fontSize11`}>
                        {stop0} <Tooltip type="stopCity" aria-label={this.props.cityNames[stopCity0]}>{stopCity0}</Tooltip>
                    </span>
                );
                if(FS[1].so) {
                    if(allStopovers.length > 0) {
                        so1 = "," + FS[1].so.name;    
                    } else {
                        so1 = "Via" + FS[1].so.name;
                    }
                    allStopovers.push(so1);
                }
            }
            if(FS.length === 3) {
                if(FS[0].so) {
                    so0 = "Via " + FS[0].so.name;
                    allStopovers.push(so0);
                }
                if(allStopovers.length === 1) {
                    stop0 = ",";
                } else {
                    stop0 = "Via"
                }
                stopCity0 = FS[0].aac;
                allStopovers.push(
                    <span className={`u-phone-fontSize11`}>
                        {stop0} <Tooltip type="stopCity" aria-label={this.props.cityNames[stopCity0]}>{stopCity0}</Tooltip>
                    </span>
                );
                if(FS[1].so) {
                    if(allStopovers.length > 0) {
                        so1 = "," + FS[1].so.name;    
                    } else {
                        so1 = "Via " + FS[1].so.name;
                    }
                    allStopovers.push(so1);
                }
                if(allStopovers.length > 0) {
                    stop1 = ",";
                } else {
                    stop1 = "Via";
                }
                stopCity1 = FS[1].aac;
                allStopovers.push(
                    <span className={`u-phone-fontSize11`}>
                        {stop1} <Tooltip type="stopCity" aria-label={this.props.cityNames[stopCity1]}>{stopCity1}</Tooltip>
                    </span>
                );
                if(FS[2].so) {
                    if(allStopovers.length > 0) {
                        so2 = ", " + FS[2].so.name;
                    } else {
                        so2 = "Via " + FS[2].so.name;
                    }
                    allStopovers.push(so2);
                }
            }
        }
    
        if (totalStop === 0) {
            if(so0) {
                stop0 = so0;
            } else {
                stop0 = "Non Stop";
            }
            stopOver = <span className={`u-phone-fontSize11`}>{stop0}</span>;
          } else if (totalStop >= 1) {
            stopOver = allStopovers;
          }
    
        if (this.props.type === 'depart') {
            tupleInner = this.props.intDepartFlights.map((flight, index) => 
                <InternationalTupleInner 
                    departFid={this.props.departFid} 
                    returnFid={this.props.returnFid} 
                    detail={flight}
                    key={index} 
                    flightSelect={this.props.flightSelect} 
                    type={this.props.type}
                    stopOver={stopOver} 
                    listIndex={index} 
                    tupleIndex={this.props.tupleIndex} />
            );
        } else if (this.props.type === 'return') {
            tupleInner = this.props.intReturnFlights.map((flight, index) => (
                <InternationalTupleInner 
                    departFid={this.props.departFid} 
                    returnFid={this.props.returnFid} 
                    detail={flight} 
                    stopOver={stopOver}
                    key={index} 
                    flightSelect={this.props.flightSelect} 
                    type={this.props.type} 
                    listIndex={index} 
                    tupleIndex={this.props.tupleIndex} />
            ));
        }
        return (
            <div className={classes.TupleDetails}>
                <div className={classes.BoxOne}>
                    <div className={classes.Timing}>
                        <div className={`u-fontSize15 u-fontWeightMedium u-textColorDark u-width44 u-textAlignLeft`}>{this.props.type === "depart" ? this.props.intDepartFlights[0].FS[0].dd : this.props.intReturnFlights[0].FS[0].dd}</div>
                        <Media query="(min-width: 599px)">
                            { matches =>
                                matches ? <img src={planeImage} alt="Plane" className={`u-phoneHide`} /> : <span className={`u-textColorDark u-lineHeight15`}>&mdash;</span>
                            }
                        </Media>
                        <div className={`u-fontSize15 u-fontWeightMedium u-textColorDark u-width44 u-textAlignRight`}>{arrivalDuration}</div>
                    </div>
                    <div className={`u-textColorDark u-fontWeightRegular u-fontSize13`}>{ this.props.type === "depart" ? this.props.intDepartFlights[0].tdu.substring(0, 2) + "h " + this.props.intDepartFlights[0].tdu.substring(3, 5) + "m" : this.props.intReturnFlights[0].tdu.substring(0, 2) + "h " + this.props.intReturnFlights[0].tdu.substring(3, 5) + "m" }</div>
                    {(this.props.onwardLength !== 'undefined' && this.props.onwardLength === 1) || (this.props.returnLength !== 'undefined' && this.props.returnLength === 1) ? (
                        <div style={{cursor: 'auto'}} className={`u-width60 u-cursorPointer u-textColorLight u-textAlignCenter u-fontSize13 u-fontWeightRegular`}>&mdash; &mdash;</div>
                    ) : <div onClick={() => this.props.expandTupleHandler(this.props.type, this.props.tupleIndex)} className={`u-width60 u-cursorPointer u-textColorPrimary u-textAlignRight u-fontSize13 u-fontWeightRegular`}>{ !this.props.isExpanded ? this.props.type === "depart" ? `+ ${this.props.intDepartFlights.length - 1} more` : `+ ${this.props.intReturnFlights.length - 1} more` : 'Close'}</div>}
                </div>
                <div className={classes.BoxTwo}>
                    <div className={classes.Cities}>
                        <div className={`u-textUppercase u-phoneHide`}>{this.props.type === 'depart' ? this.props.origin : this.props.destination}</div>
                        <div className={`u-fontSize11 u-textUppercase`}>{this.props.type === 'depart' ? 'Depart' : 'Return'} </div>
                        <div className={`u-textUppercase u-phoneHide`}>{this.props.type === 'depart' ? this.props.destination : this.props.origin}</div>
                    </div>
                    <div className={`u-phone-fontSize11`}>{stopOver}</div>
                    {(this.props.onwardLength !== 'undefined' && this.props.onwardLength === 1) || (this.props.returnLength !== 'undefined' && this.props.returnLength === 1) ? (
                        <div className={`u-width60 u-textAlignCenter u-textColorLight u-phone-fontSize11`}>&mdash; &mdash;</div>
                    ) : <div className={`u-width60 u-textAlignRight u-textColorLight u-phone-fontSize11`}>options</div>}
                </div>
                {
                    this.props.isExpanded ? <div className={`u-borderRadius4 mt-3`}>
                        <ul>
                            {tupleInner}
                        </ul>
                    </div> : null
                }
            </div>
        );
    }
}

export default InternationalTupleDetails;


// WEBPACK FOOTER //
// ./src/components/Flight/InternationalTupleRoundTrip/InternationalTupleDetails/InternationalTupleDetails.js